
// Select all video elements and their corresponding custom play/pause buttons
document.querySelectorAll('video').forEach(video => {
  // Find the parent section of interest
  const parentSection = video.closest('.video-parent-section, .video-right-card, .custom-card-item, .media-grid-slider-wrapper');
  
  // Proceed only if the video is within one of the defined sections
  if (parentSection) {
    const playButton = parentSection.querySelector('.custom-play');
    const pauseButton = parentSection.querySelector('.custom-pause');

    // Ensure play and pause buttons exist
    if (playButton && pauseButton) {
      // Function to play the video
      function playVideo() {
        video.play();
        playButton.style.display = 'none';
        pauseButton.style.display = 'block';
      }

      // Function to pause the video
      function pauseVideo() {
        video.pause();
        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
      }

      // Event listeners for custom buttons
      playButton.addEventListener('click', playVideo);
      pauseButton.addEventListener('click', pauseVideo);

      // Ensure pause button is visible initially since videos autoplay
      playButton.style.display = 'none';
      pauseButton.style.display = 'block';

      // Sync button visibility with video playback state in case of user interaction
      video.addEventListener('play', () => {
        playButton.style.display = 'none';
        pauseButton.style.display = 'block';
      });

      video.addEventListener('pause', () => {
        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
      });
    }
  }
});




// Read more on footer and other if any
document.addEventListener('DOMContentLoaded', function () {
  var readMoreBtn = document.querySelector('.readmore');
  var readLessBtn = document.querySelector('.readless');

  if (readMoreBtn) {
    readMoreBtn.addEventListener('click', function (event) {
      event.preventDefault();

      var descriptionFull = document.querySelector('.text-full');
      var descriptionShort = document.querySelector('.text-short');

      if (descriptionFull && descriptionShort) {
        descriptionFull.style.display = 'block';
        descriptionShort.style.display = 'none';
      }
    });
  }

  if (readLessBtn) {
    readLessBtn.addEventListener('click', function (event) {
      event.preventDefault();

      var descriptionFull = document.querySelector('.text-full');
      var descriptionShort = document.querySelector('.text-short');

      if (descriptionFull && descriptionShort) {
        descriptionFull.style.display = 'none';
        descriptionShort.style.display = 'block';
      }
    });
  }
});

// image scrollbar
  const imagescrollContainers = document.querySelectorAll('.img_custom-scroll-content');

  imagescrollContainers.forEach((scrollContainer) => {
    let isDown = false;
    let startX, scrollLeft;
    let isSwiping = false; // Track swipe movement

    // Mouse Events
    const onMouseDown = (e) => {
      e.preventDefault();
      isDown = true;
      isSwiping = false;
      scrollContainer.classList.add('active');
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scrollContainer.offsetLeft;
      const walk = (x - startX) * 2; // Adjust sensitivity
      scrollContainer.scrollLeft = scrollLeft - walk;
      if (Math.abs(walk) > 5) isSwiping = true;
    };

    const onMouseUp = () => {
      isDown = false;
      scrollContainer.classList.remove('active');
    };

    const onMouseLeave = onMouseUp;

    // Touch Events (For Mobile)
    let touchStartX, touchScrollLeft;

    const onTouchStart = (e) => {
      isSwiping = false;
      touchStartX = e.touches[0].pageX - scrollContainer.offsetLeft;
      touchScrollLeft = scrollContainer.scrollLeft;
    };

    const onTouchMove = (e) => {
      const x = e.touches[0].pageX - scrollContainer.offsetLeft;
      const walk = (x - touchStartX) * 2;
      scrollContainer.scrollLeft = touchScrollLeft - walk;
      if (Math.abs(walk) > 5) isSwiping = true;
    };

    // Prevent Clicks During Swipe
    const preventClickDuringSwipe = (e) => {
      if (isSwiping) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };

    // Add Event Listeners
    scrollContainer.addEventListener('mousedown', onMouseDown);
    scrollContainer.addEventListener('mousemove', onMouseMove);
    scrollContainer.addEventListener('mouseup', onMouseUp);
    scrollContainer.addEventListener('mouseleave', onMouseLeave);
    
    // Touch Support
    scrollContainer.addEventListener('touchstart', onTouchStart);
    scrollContainer.addEventListener('touchmove', onTouchMove);

    // Prevent clicks during swiping
    const gridItems = scrollContainer.querySelectorAll('.grid__item a');
    gridItems.forEach((item) => {
      item.addEventListener('click', preventClickDuringSwipe);
    });

    // Cleanup on window mouseup
    window.addEventListener('mouseup', onMouseUp);
  });


// Featured collection Scroll 
const scrollContainers = document.querySelectorAll('.custom-scroll-content');

scrollContainers.forEach((scrollContainer) => {
  let isDown = false;
  let startX;
  let scrollLeft;
  let isSwiping = false; // New flag to track swiping

  const onMouseDown = (e) => {
    e.preventDefault(); // Prevent text selection
    isDown = true;
    isSwiping = false; // Reset swipe flag
    scrollContainer.classList.add('active');
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
  };

  const onMouseLeave = () => {
    if (isDown) {
      isDown = false;
      scrollContainer.classList.remove('active');
    }
  };

  const onMouseUp = () => {
    if (isDown) {
      isDown = false;
      scrollContainer.classList.remove('active');
    }
  };

  const onMouseMove = (e) => {
    if (!isDown) return; // Stop if mouse is not down
    e.preventDefault(); // Prevent default behavior during dragging
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Adjust scroll sensitivity
    scrollContainer.scrollLeft = scrollLeft - walk;

    // Set the swiping flag if there's significant movement
    if (Math.abs(walk) > 5) {
      isSwiping = true;
    }
  };

  // Prevent clicks during swiping
  const preventClickDuringSwipe = (e) => {
    if (isSwiping) {
      e.preventDefault(); // Prevent the click event
      e.stopImmediatePropagation(); // Stop event propagation
    }
  };

  // Add Event Listeners
  scrollContainer.addEventListener('mousedown', onMouseDown);
  scrollContainer.addEventListener('mouseleave', onMouseLeave);
  scrollContainer.addEventListener('mouseup', onMouseUp);
  scrollContainer.addEventListener('mousemove', onMouseMove);

  // Add click prevention on grid items
  const gridItems = scrollContainer.querySelectorAll('.grid__item a'); // Adjust selector if needed
  gridItems.forEach((item) => {
    item.addEventListener('click', preventClickDuringSwipe);
  });

  // Ensure proper cleanup of `isDown` on mouse up outside the container
  window.addEventListener('mouseup', onMouseUp);
});


// Hide Abar
function hideAnnouncementBar() {
    document.querySelector('.announcement-bar').style.display = 'none';
}

  
// Home text icons slider mobile
document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll(".text-with-icons__block");
  let currentIndex = 0;
  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
    });
  }
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }
  showSlide(currentIndex);
  setInterval(nextSlide, 4000);
});
document.addEventListener("DOMContentLoaded", () => {
  const reviewslides = document.querySelectorAll(".testimonial-custom-slider");
  let reviewIndex = 0;
  function showSlidereview(index) {
    reviewslides.forEach((revslide, i) => {
      revslide.classList.toggle("active", i === index);
    });
  }
  function nextSlidereview() {
    reviewIndex = (reviewIndex + 1) % reviewslides.length;
    showSlidereview(reviewIndex);
  }
  showSlidereview(reviewIndex);
  setInterval(nextSlidereview, 4000);
});

/*Nav heading hide when submenu open*/ 
document.addEventListener('DOMContentLoaded', () => {
  const drawerContents = document.querySelector('.drawer__contents');

  // Use event delegation for dynamic elements and better performance
  document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.collapsible-trigger'); 
      // Exit if click is not on a trigger
      if (!trigger) return;
  
      // Check if the trigger is inside .collapsible-content__inner
      const isInsideCollapsibleContent = trigger.closest('.collapsible-content__inner') !== null;
  
      // Ignore clicks inside .collapsible-content__inner
      if (isInsideCollapsibleContent) return;
      // Get the aria-expanded state
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
  
      // Toggle the custom class on .drawer__contents based on state
      if (isExpanded) {
        drawerContents.classList.add('custom-submenu-open');
      } else {
        drawerContents.classList.remove('custom-submenu-open');
      }
  });
   document.addEventListener('click', (event) => {
      //  Link Trigger
      const triggerlink = event.target.closest('.collapsible-trigger-a');
      if (!triggerlink) return;
      const isInsideCollapsibleContentlink = triggerlink.closest('.collapsible-content__inner') !== null;
      if (isInsideCollapsibleContentlink) return;
      triggerlink.closest('div').querySelector('button').classList.add('is-open');
      triggerlink.closest('div').querySelector('button').setAttribute('aria-expanded','true');
      triggerlink.closest('div').nextElementSibling.classList.add('is-open');
      
      const isExpandedlink = triggerlink.closest('div').querySelector('button').getAttribute('aria-expanded') === 'true';
      if (isExpandedlink) {
        drawerContents.classList.add('custom-submenu-open');
      } else {
        drawerContents.classList.remove('custom-submenu-open');
      }
  });
});



// Function to update the count of active tags
function updateTagCounts() {
  document.querySelectorAll('.collection-sidebar__group').forEach((sideBarGrp) => {
    var countActive = sideBarGrp.querySelectorAll('.tag.tag--active').length;
    var countButton = sideBarGrp.querySelector('button .count');
    if (countButton) {
      countButton.innerText = countActive > 0 ? `(${countActive})` : '';
    }
  });
}

document.querySelectorAll('.tag-list .tag').forEach((tag) => {
  tag.addEventListener('click', (event) => {
    updateTagCounts(); // Update counts when a tag is clicked
  });
});
window.addEventListener('DOMContentLoaded', () => {
  updateTagCounts();
});
 



 
// World of ting tabs
const tabs = document.querySelectorAll('.world-of-ting-tabs-item a');

tabs.forEach(tab => {
  tab.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent the default anchor behavior

    // Remove 'tab-active' from all tabs
    tabs.forEach(t => t.classList.remove('tab-active'));

    // Add 'tab-active' to the clicked tab
    this.classList.add('tab-active');

    // Scroll to the corresponding section with px offset
    const targetId = this.getAttribute('href').substring(1); // Get the ID without the '#'
    const targetSection = document.getElementById(targetId);

    if (targetSection) {
      const sectionPosition = targetSection.getBoundingClientRect().top + window.pageYOffset; // Get section's position relative to the page
      const offsetPosition = sectionPosition - 150; // Add px spacing from the top

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth', // Smooth scrolling
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.querySelector('.world-of-ting-tabs'); // The element to apply the sticky class to
  const stopElement = document.querySelector('.newsletter-container'); // The element that removes the sticky class

  if (targetElement && stopElement) {
    window.addEventListener('scroll', () => {
      const scrollThreshold = 300; // Set the scroll threshold (in pixels)
      const stopElementRect = stopElement.getBoundingClientRect(); // Get the position of the .newsletter-container

      if (window.scrollY > scrollThreshold && stopElementRect.top > 0) {
        // Add the sticky class if scrolled beyond the threshold and .newsletter-container is not in view
        targetElement.classList.add('sticky-section');
      } else {
        // Remove the sticky class when scrolled back or the .newsletter-container is visible
        targetElement.classList.remove('sticky-section');
      }
    });
  } else {
     
  }
});


// Custom scrolling featured collection
class CustomHorizontalScrollBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.targetClass = this.dataset.targetClass;
    console.log(this.targetClass,'cls');
    if (!this.targetClass) {
      console.warn("CustomScrollBar: No target class specified.");
      return;
    }

    // Find the closest scrollable container
    this.targetEl = this.previousElementSibling; // Instead of closest(), we get the previous scroll-content
    console.log(this.targetEl);
    if (!this.targetEl || !this.targetEl.classList.contains(this.targetClass)) {
      console.warn(`CustomScrollBar: No element found with class "${this.targetClass}"`);
      return;
    }

    this.trackColor = this.dataset.trackColor || "#F1F3F5";
    this.trackHeight = this.dataset.trackHeight || "3px";
    this.thumbColor = this.dataset.thumbColor || "#000000";

    this.setTargetElCSS();
    this.renderScrollbar();
    this.updateThumbWidth();
    this.addEventListeners();
  }

  setTargetElCSS() {
    this.targetEl.style.overflowX = "scroll";
    this.targetEl.style.position = "relative";
    this.targetEl.style.scrollbarWidth = "none"; // Hide native scrollbar
    this.targetEl.style.msOverflowStyle = "none";
  }

  renderScrollbar() {
    // Create scrollbar container
    this.scrollbarContainer = document.createElement("div");
    this.scrollbarContainer.classList.add("custom-scrollbar");
    
    // Create track
    this.scrollbarTrack = document.createElement("div");
    this.scrollbarTrack.classList.add("custom-scrollbar__track");
    this.scrollbarContainer.appendChild(this.scrollbarTrack);

    // Create thumb
    this.scrollbarThumb = document.createElement("div");
    this.scrollbarThumb.classList.add("custom-scrollbar__thumb");
    this.scrollbarTrack.appendChild(this.scrollbarThumb);

    // Append scrollbar **after** the target scroll-content
    console.log(this.targetEl);
    this.targetEl.after(this.scrollbarContainer);
    this.addStyles();
  }

  addStyles() {
    const style = document.createElement("style");
    style.textContent = `
      .custom-scrollbar {
        width: ${this.targetEl.clientWidth}px;
        height: ${this.trackHeight};
        position: relative;
        margin-top: 0px;
      }

      .custom-scrollbar__track {
        width: 100%;
        height: 100%;
        background-color: ${this.trackColor};
        position: relative;
        border-radius: 0px;
      }

      .custom-scrollbar__thumb {
        height: 100%;
        width: 50px;
        background-color: ${this.thumbColor};
        border-radius: 0px;
        position: absolute;
        left: 0;
        cursor: grab;
        transition: background 0.2s ease-in-out;
      }

      .custom-scrollbar__thumb:hover {
        background-color: #000000;
      }
    `;
    document.head.appendChild(style);
  }

  updateThumbWidth() {
    const targetWidth = this.targetEl.clientWidth;
    const scrollWidth = this.targetEl.scrollWidth;
    const trackWidth = this.scrollbarTrack.offsetWidth;

    const thumbWidth = Math.max((targetWidth / scrollWidth) * trackWidth, 30);
    this.scrollbarThumb.style.width = `${thumbWidth}px`;
  }

  updateThumbPosition() {
    const maxScrollLeft = this.targetEl.scrollWidth - this.targetEl.clientWidth;
    const maxThumbLeft = this.scrollbarTrack.offsetWidth - this.scrollbarThumb.offsetWidth;
    const thumbLeft = (this.targetEl.scrollLeft / maxScrollLeft) * maxThumbLeft;

    this.scrollbarThumb.style.left = `${thumbLeft}px`;
  }

  addEventListeners() {
    this.targetEl.addEventListener("scroll", () => this.updateThumbPosition());

    let isDragging = false;
    let startX;

    const onMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      startX = e.clientX;

      const maxScrollLeft = this.targetEl.scrollWidth - this.targetEl.clientWidth;
      const maxThumbLeft = this.scrollbarTrack.offsetWidth - this.scrollbarThumb.offsetWidth;

      this.targetEl.scrollLeft += (deltaX / maxThumbLeft) * maxScrollLeft;
    };

    const onMouseUp = () => {
      isDragging = false;
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      document.body.style.userSelect = "auto";
    };

    this.scrollbarThumb.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.clientX;
      document.body.style.userSelect = "none";

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });
  }
}

// var url = window.location.href;
// if(url.indexOf('/cart') > -1){
//  // window.addEventListener('load', function(e) {
//  //   setTimeout(function(e){
//  //     console.log('working.. 1465')
//  //     customElements.define("custom-horizontal-scrollbar", CustomHorizontalScrollBar);   
//  //   },2000)
//  // }) 
// }else{
  customElements.define("custom-horizontal-scrollbar", CustomHorizontalScrollBar);  
// }


 
/*Scroll down - Icon with text section and header tranformation*/
document.addEventListener('DOMContentLoaded', function () {
    var headerWrapper = document.querySelector(".header-wrapper");
    var siteHeader = document.getElementById("SiteHeader");
    var hasScrolled = false;

    window.addEventListener('scroll', function () {
      // Always remove .is-light on scroll
      headerWrapper?.classList.remove("is-light");

      if (!hasScrolled && window.scrollY > 0) {
        hasScrolled = true;

        // Display and animate the section on first scroll
        document.querySelectorAll('.template-index .custom-icon-text').forEach(function (element) {
          element.style.display = 'block'; // Make it visible
          setTimeout(function () {
            element.classList.add('fade-in'); // Trigger fade-down animation
          }, 100); // Slight delay for a smoother effect
        });

        // Remove other classes and change data attribute (only once)
        headerWrapper?.classList.remove("header-wrapper--sticky");
        siteHeader?.setAttribute("data-overlay", "false");
      }
    });
  }); 

/* Collection filter sticky*/
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector(".collection-filter")){
    window.addEventListener("scroll", function () {
        if (window.scrollY > 300) {
            document.querySelector(".collection-filter").classList.add("sticky-collection-filter");
        } else {
            document.querySelector(".collection-filter").classList.remove("sticky-collection-filter");
        }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
 if(document.querySelectorAll(".ctm_scroll-container")){
    document.querySelectorAll('.ctm_scroll-container').forEach((container) => {
      const scrollbarEl = container.querySelector('.swiper-scrollbar'); // Find the scrollbar inside the container
    
      new Swiper(container, {
        // direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 10,
        // freeMode: true,
        // mousewheel: true,
        grabCursor: true,
        pagination: {
              el: ".swiper-pagination",
              clickable: true,
          },
        scrollbar: {
          el: scrollbarEl,  // Directly linking the found DOM element
          draggable: true,
          hide: true
        }
      });
      container.querySelector('.swiper-scrollbar').style.opacity = 1;
    });
   }

})



// var slider = document.querySelector('.flickity-viewport');
// var flktyInstance = Flickity.data(slider);

// slider.addEventListener('wheel', function (event) {
//   if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
//     event.preventDefault();
//     flktyInstance.x += event.deltaX * -1; // Move in direction of scroll
//     flktyInstance.positionSlider(); // Apply position update
//   }
// });


document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("scroll", function () {
        if (window.innerWidth >= 768) { // Apply only for larger screens
            const stickyButtons = document.querySelector(".sticky-buy-buttons");
            const productSticky = document.querySelector(".product-single__sticky.meta-product-content");
            const recommendationsSection = document.querySelector(".custom-class-product-recommedation");

            if (stickyButtons) { // Check if stickyButtons exists
                if (window.scrollY > 500) {
                    stickyButtons.classList.add("scrolled");
                } else {
                    stickyButtons.classList.remove("scrolled");
                }
            }

            if (productSticky && recommendationsSection) { // Check both elements exist
                // Get the position of the recommendations section
                const sectionTop = recommendationsSection.offsetTop;

                // Add a buffer of 200px to the condition
                if (window.scrollY >= sectionTop - 700) {
                    productSticky.style.setProperty("position", "relative", "important");
                } else {
                    productSticky.style.setProperty("position", "sticky", "important");
                }
            }
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("scroll", function () {
        if (window.innerWidth <= 768) { // Apply only for mobile (adjust breakpoint if needed)
            const stickyButtons = document.querySelector(".sticky-buy-buttons");
            const productSticky = document.querySelector(".product-single__sticky.meta-product-content");

            if (stickyButtons) { // Check if stickyButtons exists
                if (window.scrollY > 500) {
                    stickyButtons.classList.add("scrolled");
                } else {
                    stickyButtons.classList.remove("scrolled");
                }
            }

            if (productSticky) { // Check if productSticky exists
                if (window.scrollY > 600) {
                    productSticky.style.setProperty("position", "relative", "important");
                } else {
                    productSticky.style.removeProperty("position");
                }
            }
        }
    });
});


 
// document.addEventListener("DOMContentLoaded", function () {
//   fetch('/cart.js')
//     .then(response => response.json())
//     .then(cart => {
//       if (!cart.items.length) return;

//       const firstProductId = cart.items[0].product_id;

//       return fetch(`/recommendations/products.json?product_id=${firstProductId}&limit=8`);
//     })
//     .then(response => response.json())
//     .then(data => {
//       const container = document.querySelector("#recommended-products .products-grid .custom-scroll-content .grid");

//       if (!container) return; 
//       // Add dynamic recommendations if available
//       if (data.products && data.products.length) {
//         data.products.filter(product => product.available).forEach(product => {
//           var productHTML = `

//         <div class="grid__item grid-product small--one-half medium-up--one-fifth grid-product__has-quick-shop aos-init aos-animate" data-aos="row-of-5" data-product-handle="${product.handle}" data-product-id="${product.id}">
//           <div class="grid-product__content">
//             <a href="${product.url}" aria-label="${product.title}">
//             </a>
//            <div class="grid__item-image-wrapper">
//             <a href="${product.url}" aria-label="${product.title}">
//              <div class="grid-product__image-mask">
//                <div class="ctm_scroll-container swiper swiper-horizontal swiper-backface-hidden">
//                 <div class="swiper-wrapper" style="cursor: grab;" aria-live="polite">
//                    <div class="swiper-slide" role="group">
//                     <div class="grid__image-ratio grid__image-ratio--square">
//                       <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
//                         <img src="${product.images[0]}" alt="${product.title}" width="${product.media[0].width}" height="${product.media[0].height}" loading="lazy" class=" image-style--image-element">
//                       </image-element>
//                       </div>
//                     </div>
                              
//                     <div class="swiper-slide" role="group">
//                       <div class="grid-product__secondary-image"> 
//                        <image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">
//                         <img src="${product.images[1]}" alt="${product.title}" width="${product.media[1].width}" height="${product.media[1].height}" loading="lazy" class="image-style--image-element">
//                       </image-element>
//                       </div>
//                     </div>
                  
//                    </div>
                  
//                      <div class="swiper-pagination"></div>
//                      <div class="swiper-scrollbar"></div>
                  
//                   </div>
//                 </div>
//                </a>
//                 <a href="${product.url}" class="grid-product__link" aria-label="${product.url}">
//                   <div class="grid-product__meta">
//                      <div style="" class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" data-id="${product.id}" data-auto-install="false" data-widget-name="preview_badge" data-impressions-tracked="true" data-views-tracked="true">
//                       </div>
//                       <div class="grid-product__title grid-product__title--body">${product.title}</div>
//                     <div class="grid-product__price">${techno_formatMoney(product.variants[0].price)}</div>
//                   </div>
//                 </a>
//                </div>
                        
//               </div>
//               `

//            if(product.available){
//              productHTML += `<div class="product-tags-wrapper btn-text-atc">
                
//                   <button class="quick-product__btn ctm_add_to_cart" data-id="${product.variants[0].id}">
//                   + Add to Cart
//                   </button>
//                 </div>
//               </div>
//             `;
//            }else{
//               productHTML += `<div class="product-tags-wrapper btn-text-atc">
//                     <a class="BIS_trigger" data-product-data='${JSON.stringify(product)}'>
//                     Join Waitlist
//                     </a>
//                   </div>
//                 </div>
//               `;
//            }
           
//           container.innerHTML += productHTML;
//         });
//         customElements.define("custom-horizontal-scrollbar", CustomHorizontalScrollBar);   
//         if(document.querySelectorAll(".ctm_scroll-container")){
//           document.querySelectorAll('.ctm_scroll-container').forEach((container) => {
//             const scrollbarEl = container.querySelector('.swiper-scrollbar'); // Find the scrollbar inside the container
          
//             new Swiper(container, {
//               // direction: 'horizontal',
//               slidesPerView: 1,
//               spaceBetween: 10,
//               // freeMode: true,
//               // mousewheel: true,
//               grabCursor: true,
//               pagination: {
//                     el: ".swiper-pagination",
//                     clickable: true,
//                 },
//               scrollbar: {
//                 el: scrollbarEl,  // Directly linking the found DOM element
//                 draggable: true,
//                 hide: true
//               }
//             });
//             container.querySelector('.swiper-scrollbar').style.opacity = 1;
//           });
//          }
//       } else {
//         document.getElementById('recommended-products').style.display = 'none';
//       }
//     })
//     .catch(error => {
//       console.error('Recommendation error:', error);
//       const recommendedSection = document.getElementById('recommended-products');
//       if (recommendedSection) {
//         recommendedSection.style.display = 'none';
//       }
//     });
// });

 




 